import { Box, Theme } from '@mui/material';

import { scanDataWarningColor } from '@occc-app/themes/colors';

export type StatusDotVariant = 'success' | 'warning' | 'error' | 'default';

type StatusDotProps = {
  variant: StatusDotVariant;
};

export const getDotColor = (theme: Theme, variant: StatusDotVariant) => {
  if (variant === 'default') {
    return theme.palette.text.disabled;
  }

  // The theme's `warning.main` is orange (#FF8F00); the Scan Data warning state calls for yellow per
  // design (OCST-33438). `warning` is only ever produced for the Scan Data column, so using the dedicated
  // `scanDataWarningColor` const keeps every other MUI `warning` element unchanged.
  if (variant === 'warning') {
    return scanDataWarningColor;
  }

  return theme.palette[variant].main;
};

export const StatusDot = ({ variant }: StatusDotProps) => (
  <Box
    component='span'
    data-testid='status-dot'
    data-variant={variant}
    sx={(theme) => ({
      display: 'inline-block',
      width: 8,
      height: 8,
      borderRadius: '50%',
      flexShrink: 0,
      backgroundColor: getDotColor(theme, variant),
    })}
  />
);
